import { apiCall } from "./service";
import {
  BASE_URL,
  URL_CLIENT,
  URL_CLIENT_RESOURCES,
  URL_PORTFOLIO_RESOURCES,
  URL_PROGRAM_RESOURCES,
  URL_PROJECT_RESOURCES,
} from "./URL";
export const api = {
  getAllocatedResourcesRequest(params) {
    const { parent, search, id, page, size } = params;
    const paginationParams = { pageNumber: page, pageSize: size };
    let url;
    
    switch (parent) {
      case "Client":
        url = `${BASE_URL}Clients/${id}/Resources`;
        break;
        
      case "Portfolio":
        url = `${BASE_URL}Portfolios/${id}/Resources`;
        break;
        
      case "Program":
        url = `${BASE_URL}Programs/${id}/Resources`;
        break;
        
      default:
        url = `${BASE_URL}Projects/${id}/Resources`;
    }
  
    if (search) {
      paginationParams.searchTerm = search;
    }

    const queryParams = new URLSearchParams(paginationParams).toString();
    const fullUrl = `${url}?${queryParams}`;
  
    return apiCall.pagination({ url: fullUrl });
  },
  sortAllocatedResourcesRequest(params) {
    let baseUrl;
    if (params.parent === "Client") baseUrl = URL_CLIENT_RESOURCES(params.id);
    if (params.parent === "Portfolio")
      baseUrl = URL_PORTFOLIO_RESOURCES(params.id);
    if (params.parent === "Program") baseUrl = URL_PROGRAM_RESOURCES(params.id);
    if (params.parent === "Project") baseUrl = URL_PROJECT_RESOURCES(params.id);

    return apiCall.pagination({
      url: `${baseUrl}?pageNumber=${params.page}&pageSize=${params.size}&orderby=${params.orderBy}`,
      isAuthToken: true,
      params,
    });
  },
};

export default api;
